/**
 * The URL of Pearl
 */
const pearlUrl = 'https://pearl.eassist.me';
export default pearlUrl;
